import styled from 'styled-components';

import { COLOR_WHITE, COLOR_GRAY_30 } from 'styles/variables/colors';

export const RegisterCard = styled.div`
  width: 322px;
  padding: 33px;
  background: ${COLOR_WHITE};
  border: 1px solid ${COLOR_GRAY_30};
  border-radius: 2px;
  box-shadow: 0px 3px 6px #00000029;

  @media (max-width: 768px) {
    display: 'none';
  }
`;

export const RegisterHeader = styled.header`
  display: flex;
  margin-bottom: 15px;
`;

export const RegisterHeaderInner = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
`;

export const StemImage = styled.img`
  width: 30%;
  margin-right: 20px;
`;

export const RegisterTitle = styled.h3`
  font-size: 20px;
  margin: 0;
  color: #d6246e;
`;

export const RegisterFooter = styled.footer`
  margin-top: 15px;
`;

export const Grid = styled.div`
  display: flex;
  margin-bottom: 27px;
  align-items: flex-start;

  & > div:first-child {
    margin-right: 60px;
  }
`;

export const RelatedSection = styled.div`
  margin: 0 0 40px 0;
`;

export const RelatedTitle = styled.h2``;

export const RelatedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(122px, 1fr));
  grid-gap: 85px 20px;
  padding-bottom: 150px;

  @media (max-width: 768px) {
    display: flex;
    overflow-y: hidden;
    overflow-x: scroll;
    padding-bottom: 130px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  width: 252px;
  background-color: #707070;
  margin: -5px 0px 15px;
`;

export const DescriptionIllustration = styled.p`
  font-size: 16px;
  font-family: 'Lato';
  margin: 0px;
`;

export const MainDividerIllustration = styled.div`
  background-color: #bfbfbf;
  height: 1px;
  width: 100%;
  margin-top: 25px;
`;

export const MainLoginForMobile = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px 35px;
`;

export const LoginForMobile = styled.div`
  width: 335px;
  height: 180px;
  box-shadow: 0px 3px 6px #00000029;
  border-top: 1px solid #e6e6e6;
  display: grid;
  justify-items: center;
  padding: 20px 0px;
`;

export const RegisterTitleMobile = styled.p`
  font-size: 32px;
  font-weight: bold;
  margin: 0px 0px 13px 0px;
  color: #d6246e;
`;

export const ButtonSignUpMobile = styled.a`
  background-color: #7833ff;
  border-radius: 40px;
  padding: 8px 28px;
  color: #fff;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`;
